import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import RichText from '../controls/RichText';
import EasyAccordion from '../controls/EasyAccordion';
import DestructiveButton from '../controls/DestructiveButton';
import { useForceUpdate, numberToLetter, getRawText } from '../util';
import TaskSlider from '@bittnerdevelopmentgroup/interactive/dist/TaskSlider/TaskSlider';
import { Content } from '../DataStructures';
import { TabContextReporter } from '../TabContext';
import { HotspotEditor } from './TaskCallout';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
export default function TaskDragDrop(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const hotspots = dataProps.hotspots;
  const picture = dataProps.picture;
  return /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Initial Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image URL:"), " ", /*#__PURE__*/React.createElement("i", null, "A direct link to the image.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.picture,
    onChange: e => {
      dataProps.picture = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image Alt Text:"), " ", /*#__PURE__*/React.createElement("i", null, "A litteral description.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.pictureAlt,
    onChange: e => {
      dataProps.pictureAlt = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: getRawText(dataProps.pictureAlt).length > 0
  }, "Please enter alt text.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Label Width:")), /*#__PURE__*/React.createElement(TaskSlider, {
    handleChange: value => {
      dataProps.labelWidth = `${value}px`;
      forceUpdate();
      props.onChanged();
    },
    start: parseInt(dataProps.labelWidth),
    min: 60,
    max: 230,
    step: 1,
    tooltip: "auto"
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Correct Feedback:")), /*#__PURE__*/React.createElement(RichText, {
    key: "multiselect-correct",
    value: dataProps.correctFeedback,
    onChange: v => {
      dataProps.correctFeedback = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Incorrect Feedback:")), /*#__PURE__*/React.createElement(RichText, {
    key: "multiselect-incorrect",
    value: dataProps.incorrectFeedback,
    onChange: v => {
      dataProps.incorrectFeedback = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Button, {
    block: true,
    variant: "success",
    onClick: () => {
      const letter = numberToLetter(dataProps.choices.length);
      dataProps.choices.push({
        content: new Content("Choice " + letter),
        accessible: "choice" + letter,
        accessibleLabel: "Choice " + letter
      });
      hotspots.push({
        correct: [dataProps.choices.length - 1],
        hotspotLabel: new Content("Hotspot alt text"),
        style: {
          top: "70px",
          left: "70px",
          width: "135px",
          height: "70px"
        }
      });
      forceUpdate();
      props.onChanged();
    }
  }, "Add New Hotspot"))), hotspots.map((hotspot, i) => {
    const letter = numberToLetter(i);
    return /*#__PURE__*/React.createElement(TabContextReporter, {
      index: String(i + 1),
      title: "Hotspot " + String(i + 1)
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Position and Size:")), /*#__PURE__*/React.createElement(HotspotEditor, {
      hs: hotspots[i],
      picture: picture,
      forceUpdate: forceUpdate,
      triggerStateUpdate: props.triggerStateUpdate
    })), /*#__PURE__*/React.createElement(DestructiveButton, {
      size: "sm",
      variant: "danger",
      title: "Remove choice",
      text: "Remove this hotspot",
      confirmation: "Are you sure?",
      className: "fs-sm",
      onClick: e => {
        e.stopPropagation();
        e.preventDefault();
        dataProps.choices.splice(i, 1);
        for (const hotspot of hotspots) {
          for (let j = 0; j < hotspot.correct.length; ++j) {
            if (hotspot.correct[j] === i) {
              hotspot.correct.splice(j, 1);
              --j;
            } else if (hotspot.correct[j] > i) {
              --hotspot.correct[j];
            }
          }
        }
        hotspots.splice(i, 1);
        props.decrementActiveTab();
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(Form.Group, {
      style: {
        marginTop: "15px"
      }
    }, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Accessible Label:"), " ", /*#__PURE__*/React.createElement("i", null, "A literal description of the hotspot area.")), /*#__PURE__*/React.createElement(Form.Control, {
      as: "textarea",
      value: hotspot.hotspotLabel,
      onChange: e => {
        hotspot.hotspotLabel = e.target.value;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: getRawText(hotspot.hotspotLabel).length > 0
    }, "Please enter an accessible label.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Choice Text:")), /*#__PURE__*/React.createElement(RichText, {
      inlineOnly: true,
      value: dataProps.choices[i].content,
      onChange: v => {
        dataProps.choices[i].content = v;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "primary",
      onClick: () => {
        let fullPath = props.path.slice();
        fullPath.push("props", "choices", i, "content");
        props.scopeToItem(fullPath);
      }
    }, "Add Components")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Correct Choices:")), dataProps.choices.map((choice, i) => {
      const letter2 = numberToLetter(i);
      return /*#__PURE__*/React.createElement(Row, {
        key: letter2
      }, /*#__PURE__*/React.createElement(Col, {
        xs: "auto"
      }, /*#__PURE__*/React.createElement(Form.Check, {
        type: "checkbox",
        id: `dragdrop-check-${letter}-${letter2}`,
        checked: hotspot.correct.includes(i),
        onChange: e => {
          if (e.target.checked) {
            hotspot.correct.push(i);
          } else {
            let index = hotspot.correct.indexOf(i);
            if (index !== -1) {
              hotspot.correct.splice(index, 1);
            }
          }
          forceUpdate();
          props.onChanged();
        }
      })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, {
        for: `dragdrop-check-${letter}-${letter2}`
      }, "Choice ", letter2)));
    })));
  }));
}